import { render, staticRenderFns } from "./PayIco.vue?vue&type=template&id=701d507c&scoped=true&"
import script from "./PayIco.vue?vue&type=script&lang=js&"
export * from "./PayIco.vue?vue&type=script&lang=js&"
import style0 from "./PayIco.vue?vue&type=style&index=0&id=701d507c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d507c",
  null
  
)

export default component.exports